import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAbonneInfo_allRight } from "../../services/abonne/AbonneRequest";

// images
import LOGO_MTN2 from "./../../assets/images/mtn-logo.svg";

const NotUser = () => {
  const navigate = useNavigate();

  useEffect(() => {
    getAbonneInfo_allRight()
      .then((res) => {
        navigate('/forfait')
      })
      .catch((err) => {
        console.log("api error", err.response);
        if (err.response.status === 403) {
          navigate('/not-allowed')
        }
      });
  }, []);

  return (
    <div className="w-full h-screen bg-gray-mtn flex flex-col items-center pt-32">
      <div className="mb-10">
        <img src={LOGO_MTN2} alt="" className="w-32" />
      </div>
      <div className="max-w-md h-fit bg-white shadow-xl rounded-xl border mx-3 p-5">
        <h1 className="text-center text-red-600 text-2xl font-bold mx-5">
          Accès refusé
        </h1>
        <div className="mt-5">
          <p className="font-normal text-sm text-gray-500 text-center">
            Désolé vous ne pouvez pas accéder à cette page parce que vous n'êtes pas un abonné MTN.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotUser;
